import React from "react";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import ApiClient from "../../../common/API";
import { useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import handleError from "../ErrorHandling"

export default function DeleteUser({ user, isOpen, setsetIsOpen }) {
    const queryClient = useQueryClient();

    const closeModal = () => {
        setsetIsOpen(false);
    };

    const handleDelete = () => {
        ApiClient().delete(`user/${user.id}/`)
            .then(() => {
                queryClient.invalidateQueries(['user'])
                closeModal();
                return toast.success('User deleted!');
            })
            .catch(error => {
                console.error(error);
                const errorMessage = handleError(error, "User", "delete");
                return toast.error(errorMessage);
            });
    };

    return (
        <>
            {isOpen && (
                <ConfirmationModal
                    isOpen={isOpen}
                    onClose={closeModal}
                    onConfirm={handleDelete}
                    icon={<DeleteIcon sx={{ fontSize: '60px' }} color="error" />}
                    title="Delete User"
                    message={`Are you sure you want to delete "${user.first_name} ${user.last_name}" (${user.email})? This action cannot be undone.`}
                />
            )}
        </>
    )
}
